import { isNil } from "lodash";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export interface TableFilter {
	field: string;
	value?: any;
	operator: string;
}

export const useBuildTableFilters = (paramMap: Record<string, TableFilter>) => {
	const [searchParams] = useSearchParams();

	const filters = useMemo(() => {
		return Object.entries(paramMap).reduce((filterItems, [param, filter]) => {
			const value = searchParams.get(param);
			if (!isNil(value)) {
				filterItems.push({
					field: filter.field,
					operator: filter.operator,
					value,
				});
			}
			return filterItems;
		}, [] as Array<TableFilter>);
	}, [searchParams, paramMap]);

	return filters;
};
